import { Slide } from '@mui/material';
import { FC, ReactNode } from 'react';
import { usePrevious } from 'react-utils';

const OxTabPanel: FC<React.PropsWithChildren<OxTabPanelProps>> = ({
  children,
  activeIndex,
  index,
}) => {
  const prevActiveIndex = usePrevious(activeIndex) || -1;
  const direction = prevActiveIndex < activeIndex ? 'right' : 'left';
  const active = activeIndex === index;

  return (
    <Slide
      data-testid='tab-panel'
      appear={false}
      direction={direction}
      in={active}>
      <div hidden={!active}>{active && children}</div>
    </Slide>
  );
};

interface OxTabPanelProps {
  index: number;
  activeIndex: number;
  children?: ReactNode;
}

export default OxTabPanel;
